<template>
  <div class="rounded-borders-lg bdr-a-grey-6 q-pa-lg column items-center">
    <div class="row justify-center" v-if="img">
      <img
        :src="img"
        alt="Lease Vehicle"
        class="image-contain q-mb-lg"
        :style="{ width: imgWidth }"
      />
    </div>
    <h6 class="q-mb-md text-application-primary text-center text-weight-bold">
      We are working to complete your lease activation for {{ title }}
    </h6>
    <p class="text-center">
      Come back in 24hrs or call
      <SAILink
        class="text-weight-bold"
        :href="contactNumber"
        target="_blank"
        :label="contactNumber"
      />
      if you have any issues.
    </p>
  </div>
</template>

<script>
import { SAILink } from 'ecx.saigon.ui.common';

export default {
  name: 'LeaseWithoutDataCard',
  props: {
    title: String,
    contactNumber: String,
    img: String,
    imgWidth: {
      type: String,
      default: '180px'
    }
  },
  components: {
    SAILink
  }
};
</script>
